import { Box, Button, Switch, Text, useToast } from '@chakra-ui/react';
import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { dispatchExperienceToAnalytics } from '../../analytics';
import { Copy } from '../../Icons/Copy';
import { useExperiencesStore } from '../../store/experiences';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useUserStore } from '../../store/user';
import configureAxios from '../../axiosClient';
import { Eye } from '../../Icons/Eye';
import { ArrowLeftIcon, EditIcon } from '@chakra-ui/icons';
import SceneDropDown from './SceneDropDown';
import { useCommunityStore } from '../../store/community';
import EditWarning from './EditWarning';

const axiosClient = configureAxios();

function ViewerNavbar({
  isV2Experience,
  isStandardUIReady,
}: {
  isV2Experience: boolean;
  isStandardUIReady: boolean;
}) {
  const toast = useToast({
    position: 'top',
    variant: 'top-accent',
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [param] = useSearchParams();
  const isCommunityExperience = param.get('isCommunity');
  const {
    selectedExperience,
    selectedExperienceScenes,
    // setSelectedExperience,
    setViewerUnPublishExperienceModalActive,
    setPublishExperienceModalActive,
  } = useExperiencesStore();
  const { setIsFeaturedExperience } = useCommunityStore();
  const { organisation, user } = useUserStore();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSharingToCommunity, setIsSharingToCommunity] = useState(false);
  const [debugActive, setDebugActive] = useState(false);
  // const [isV2Experience, setIsV2Experience] = useState(false);
  // const [isStandardUIReady, setIsStandardUIReady] = useState(false);
  const [showSceneChanger, setShowSceneChanger] = useState(false);
  const [selectedScene, setSelectedScene] = useState('');
  const [openEditWarning, setOpenEditWarning] = useState(false);
  const [publishToggle, setPublishToggle] = useState<boolean>(
    !!selectedExperience.published_url
  );
  const previousPathname = location.state?.from || '/';

  // Reference date: 3 PM on August 30th, 2024
  const referenceDate = new Date('2024-08-30T00:00:00');

  useEffect(() => {
    if (selectedExperience && selectedExperience.created) {
      const experienceCreatedDate = new Date(selectedExperience.created);
      setPublishToggle(!!selectedExperience.published_url);

      if (
        process.env.NODE_ENV === 'production' //prod & staging
      ) {
        if (experienceCreatedDate.getTime() > referenceDate.getTime()) {
          setShowSceneChanger(true);
        } else {
          setShowSceneChanger(false);
        }
      } else {
        //local
        setShowSceneChanger(true);
      }
    }
  }, [selectedExperience]);

  useEffect(() => {
    setSelectedScene(selectedExperienceScenes[0]?.name);

    return () => {
      setSelectedScene('');
    };
  }, [selectedExperienceScenes]);

  const activateDebugMode = (event: ChangeEvent<HTMLInputElement>) => {
    setDebugActive(event.target.checked);
    const iframe = document.getElementById(
      'experience-container'
    ) as HTMLIFrameElement;
    if (event.target.checked) {
      iframe.src = iframe.src + '?debug=true';
    } else {
      iframe.src = iframe.src.replace('?debug=true', '');
    }
  };

  const handlePublish = () => {
    if (
      publishToggle &&
      selectedExperience.published_url &&
      selectedExperience.published_url?.length > 0
    ) {
      setViewerUnPublishExperienceModalActive(true);
    } else {
      // publishExperience();
      setPublishExperienceModalActive(true);
    }
  };

  const DelistCommunityExperience = async () => {
    setIsSubmitting(true);
    try {
      const res = await axiosClient.delete(
        `experience/delist/${organisation.organizationId}/${selectedExperience.id}`
      );
      toast({
        title: res.data.data,
        status: 'success',
      });
      navigate('/');
      setIsSubmitting(false);
    } catch (error) {
      console.log('Error ', error);
      setIsSubmitting(false);
    }
  };

  const ShareToCommunity = async () => {
    setIsSharingToCommunity(true);
    try {
      const res = await axiosClient.post(
        `experience/list/${organisation.organizationId}/${selectedExperience.id}`,
        {
          name: selectedExperience.name,
          tag_list: [],
        }
      );
      toast({
        title: res.data.data,
        status: 'success',
      });
      setIsFeaturedExperience(false);
      setIsSharingToCommunity(false);
      navigate('/community');
    } catch (error) {
      console.log('Error ', error);
      setIsSharingToCommunity(false);
    }
  };

  // const publishExperience = () => {
  //   const userOrgId = organisation.organizationId;

  //   setIsSubmitting(true);
  //   axiosClient
  //     .post(`/experience/publish/${userOrgId}/${selectedExperience.id}`)
  //     .then((res) => {
  //       const isStatusOk = res.data.status === 'OK';
  //       if (isStatusOk) {
  //         dispatchExperienceToAnalytics('publish_experience', {
  //           experience_id: selectedExperience.id,
  //           organisation_id: userOrgId,
  //           organisation_user_id: user.id,
  //           experience_name: selectedExperience.name,
  //           experience_draft_url: selectedExperience.preview_url,
  //           experience_published_url: res.data?.data?.published_url,
  //         });
  //         if (res?.data?.data?.error?.length > 0) {
  //           toast({
  //             title: `A problem occurred publishing the experience.`,
  //             status: 'error',
  //           });
  //         }
  //         // else {
  //         //   setSelectedExperience({
  //         //     ...selectedExperience,
  //         //     published_url: res.data?.data?.published_url,
  //         //   });
  //         //   toast({
  //         //     title: `Your experience was published successfully.`,
  //         //     status: 'success',
  //         //   });
  //         //   setShareCommunityExperienceModalActive(true);
  //         // }
  //       } else {
  //         if (res.data.data === 'Insufficient Permissions.') {
  //           toast({
  //             title: `Insufficient Permissions`,
  //             status: 'info',
  //           });
  //         } else {
  //           toast({
  //             title: `A problem occurred publishing the experience.`,
  //             status: 'error',
  //           });
  //         }
  //       }
  //       setIsSubmitting(false);
  //     })
  //     .catch((err: unknown) => {
  //       console.log(err);
  //       setIsSubmitting(false);
  //       toast({
  //         title: `A problem occurred publishing the experience.`,
  //         status: 'error',
  //       });
  //     });
  // };

  const handleCopy = async (text: string, toastMessage?: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }
        textArea.remove();
      }
      if (!toast.isActive('viewerLink')) {
        toast({
          id: 'viewerLink',
          title: toastMessage,
          status: 'success',
        });
      }
    } catch (err) {
      console.error('Async: Could not copy text', err);
    }
  };

  // useEffect(() => {
  //   const eventListener = (event: Event) => {
  //     console.log('in dashboard eventListener', event);
  //     const interceptedEvent = event as CustomEvent;
  //     if (interceptedEvent.detail.name === 'experienceReady') {
  //       console.log('experienceReady', interceptedEvent);
  //       const expVer = interceptedEvent.detail.data.version;
  //       if (expVer.includes('Fabv2.0.0')) {
  //         setIsV2Experience(true);
  //       } else {
  //         setIsV2Experience(false);
  //       }
  //     }
  //     if (interceptedEvent.detail.name === 'uiReady') {
  //       console.log('uiReady on Dash');
  //       setIsStandardUIReady(true);
  //     }
  //   };

  //   const fromUserInterface = async (event: Event) => {
  //     const interceptedEvent = event as CustomEvent;
  //     if (interceptedEvent.detail.name === 'updateUIDataOnS3') {
  //       console.log('updateUIDataOnS3', interceptedEvent);
  //       try {
  //         const response = await axiosClient.post(
  //           `experience/update/data`,
  //           interceptedEvent.detail.data
  //         );
  //         console.log('response updateDataOnS3', response);
  //         if (response.data.status === 'OK') {
  //           window.emperia &&
  //             window.emperia.events.dispatchEvent(
  //               new CustomEvent('fromDashboard', {
  //                 detail: {
  //                   name: 'DataUpdatedOnS3',
  //                   data: 'success',
  //                 },
  //               })
  //             );
  //         }
  //       } catch (error) {
  //         window.emperia &&
  //           window.emperia.events.dispatchEvent(
  //             new CustomEvent('fromDashboard', {
  //               detail: {
  //                 name: 'DataUpdatedOnS3',
  //                 data: 'error',
  //               },
  //             })
  //           );
  //       }
  //     }
  //   };

  //   const target = window?.emperia?.events || window;
  //   console.log('listeners added');
  //   target.addEventListener('fromExperience', eventListener);
  //   target.addEventListener('fromUserInterface', fromUserInterface);

  //   return () => {
  //     target.removeEventListener('fromExperience', eventListener);
  //     target.removeEventListener('fromUserInterface', fromUserInterface);
  //   };
  // }, []);

  const togglePublishedMode = (event: ChangeEvent<HTMLInputElement>) => {
    setPublishToggle(event.target.checked);

    window.emperia.refresh({
      id: 'experience-root',
      experience_url:
        selectedExperience.published_url && event.target.checked
          ? selectedExperience.published_url?.replace('index', 'experience')
          : selectedExperience.preview_url?.replace('index', 'experience') ||
            '', // fallback to empty string if preview_url is undefined
      ui_url: process.env.REACT_APP_STANDARD_UI_URL as string,
      attach_ui: true,
      debug: false,
      organization_id: '587accae-22f4-41e4-86c6-fa83d20e7f65',
    });
  };

  return (
    <Fragment>
      <Box
        transition='all 0.2s'
        // position='absolute'
        height={['65px']}
        borderBottom='1px solid rgba(242, 243, 245, 0.14)'
        background='rgba(8, 16, 29, 0.60)'
        backdropFilter='blur(20px)'
        color='#fff'
        textAlign='center'
        zIndex={50}
        width={['100%']}
        padding={['0px 20px']}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Box
          height={['inherit']}
          width={['auto']}
          display='flex'
          alignItems='center'
          justifyContent='center'
          gap={3}
        >
          <ArrowLeftIcon
            boxSize={[4]}
            stroke='white'
            cursor='pointer'
            onClick={() => navigate(previousPathname)}
          />
          <Box
            height={['inherit']}
            width={['auto']}
            display='flex'
            flexDirection='column'
            alignItems='flex-start'
            justifyContent='center'
          >
            <Text fontFamily='Normal' fontSize={['15px']}>
              {selectedExperience.name + ' ' + selectedExperience.description}
            </Text>
            {publishToggle && (
              <Text
                fontFamily='Normal'
                fontSize={['13px']}
                color='#4DFF7B'
                maxW={['150px']}
                noOfLines={1}
              >
                {selectedExperience.published_url}
              </Text>
            )}
          </Box>
          {publishToggle && selectedExperience.published_url && (
            <Button
              variant='link'
              leftIcon={<Copy stroke='currentColor' boxSize={[4]} />}
              fontFamily='Normal'
              fontSize={['12px']}
              color='#FFFFFF'
              onClick={() =>
                selectedExperience.published_url &&
                handleCopy(selectedExperience.published_url, 'Link Copied')
              }
            >
              Copy Link
            </Button>
          )}

          <Button
            rightIcon={
              <Switch
                id='toggle-debug'
                size='sm'
                colorScheme='blue'
                isChecked={debugActive}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  activateDebugMode(event);
                  dispatchExperienceToAnalytics('view_debug_mode', {
                    experience_id: selectedExperience.id,
                    organisation_id: organisation.organizationId,
                    organisation_user_id: user.id,
                    experience_name: selectedExperience.name,
                    experience_draft_url: selectedExperience.preview_url,
                    experience_published_url: selectedExperience.published_url,
                  });
                }}
              />
            }
            padding='0px'
            variant='ghost'
            background='transparent'
            _hover={{
              bg: 'transparent',
            }}
            _active={{
              bg: 'transparent',
            }}
            _focus={{
              bg: 'transparent',
            }}
            color='white'
            fontFamily='Normal'
            fontSize={['12px']}
          >
            Debug
          </Button>

          <Button
            rightIcon={
              <Switch
                id='toggle-debug'
                size='sm'
                colorScheme='blue'
                isChecked={publishToggle}
                disabled={selectedExperience.published_url === ''}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  togglePublishedMode(event);
                }}
              />
            }
            padding='0px'
            variant='ghost'
            background='transparent'
            _hover={{
              bg: 'transparent',
            }}
            _active={{
              bg: 'transparent',
            }}
            _focus={{
              bg: 'transparent',
            }}
            color='white'
            fontFamily='Normal'
            fontSize={['12px']}
            disabled={selectedExperience.published_url === ''}
          >
            Currently Viewing: {publishToggle ? 'Published' : 'Unpublished'}
          </Button>

          {isV2Experience && isStandardUIReady && !publishToggle && (
            <Button
              rightIcon={<EditIcon boxSize={[4]} stroke='currentColor' />}
              ml={5}
              padding='0px'
              variant='ghost'
              background='transparent'
              _hover={{
                bg: 'transparent',
              }}
              _active={{
                bg: 'transparent',
              }}
              _focus={{
                bg: 'transparent',
              }}
              color='white'
              fontFamily='Normal'
              fontSize={['12px']}
              onClick={() => {
                window.emperia &&
                  window.emperia.events.dispatchEvent(
                    new CustomEvent('fromDashboard', {
                      detail: {
                        name: 'openEditor',
                      },
                    })
                  );
              }}
            >
              Edit
            </Button>
          )}
        </Box>

        <Box
          height={['inherit']}
          width={['auto']}
          display='flex'
          alignItems='center'
          gap={3}
        >
          {selectedExperience?.community_url?.length === 0 &&
            !selectedExperience.is_community_shared && (
              <Button
                textTransform='uppercase'
                width={['auto', 'auto', 'auto']}
                variant='outline'
                color='#08101D'
                background='white'
                border='1px solid rgba(242, 243, 245, 0.14)'
                fontFamily='Metal'
                fontSize={['14px', '14px', '15px']}
                borderRadius='30px'
                _hover={{
                  bg: '#D3BB8A',
                }}
                isLoading={isSharingToCommunity}
                onClick={ShareToCommunity}
              >
                Share to community
              </Button>
            )}
          {showSceneChanger && (
            <Box display='flex' alignItems='center' gap={2}>
              <Eye stroke={'#fff'} boxSize={[5]} />
              <Text fontFamily='Normal' fontSize={['14px']}>
                View scene:
              </Text>
              <SceneDropDown
                selectedScene={selectedScene}
                setSelectedScene={setSelectedScene}
                scenes={selectedExperienceScenes}
                handleCopy={handleCopy}
              />
            </Box>
          )}

          {!isCommunityExperience &&
            selectedExperience.published_url &&
            selectedExperience.published_url?.length > 0 &&
            publishToggle && (
              <Button
                textTransform='uppercase'
                width={['auto', 'auto', 'auto']}
                variant='outline'
                color='#08101D'
                background='white'
                border='1px solid rgba(242, 243, 245, 0.14)'
                fontFamily='Metal'
                fontSize={['14px', '14px', '15px']}
                borderRadius='30px'
                _hover={{
                  bg: '#D3BB8A',
                }}
                onClick={() =>
                  window.open(selectedExperience.published_url, '_blank')
                }
              >
                View Published Version
              </Button>
            )}

          {!isCommunityExperience && (
            <Button
              textTransform='uppercase'
              width={['auto', 'auto', 'auto']}
              variant='outline'
              color='#08101D'
              background='white'
              border='1px solid rgba(242, 243, 245, 0.14)'
              fontFamily='Metal'
              fontSize={['14px', '14px', '15px']}
              borderRadius='30px'
              _hover={{
                bg: '#D3BB8A',
              }}
              // isLoading={isSubmitting}
              onClick={handlePublish}
            >
              {publishToggle
                ? selectedExperience.published_url &&
                  selectedExperience.published_url?.length > 0
                  ? 'UnPublish'
                  : 'Publish'
                : 'Publish'}
            </Button>
          )}

          {isCommunityExperience && (
            <Button
              textTransform='uppercase'
              width={['auto', 'auto', 'auto']}
              variant='outline'
              color='#08101D'
              background='white'
              border='1px solid rgba(242, 243, 245, 0.14)'
              fontFamily='Metal'
              fontSize={['14px', '14px', '15px']}
              borderRadius='30px'
              _hover={{
                bg: '#D3BB8A',
              }}
              isLoading={isSubmitting}
              onClick={DelistCommunityExperience}
            >
              Delist From Community
            </Button>
          )}
        </Box>
      </Box>
      <EditWarning
        open={openEditWarning}
        isSubmitting={isSubmitting}
        setOpenEditWarning={setOpenEditWarning}
      />
    </Fragment>
  );
}

export default ViewerNavbar;
